import React from "react";
import { Stack, Text } from "sprint-common-web";

import { OrderResolutionDimensions, stringifyOrderResolutionDimensions } from "../../types/OrderResolutionDimensions";

type RenderOrderResolutionProps = {
    targetResolution?: OrderResolutionDimensions;
    sourceResolution?: OrderResolutionDimensions;
};

const MISSING_VALUE_PLACEHOLDER = "-";

export function renderOrderResolutions<T extends RenderOrderResolutionProps>(props?: T): JSX.Element {
    if (!props) return <></>;

    const { sourceResolution, targetResolution } = props;

    const targetResText = targetResolution
        ? stringifyOrderResolutionDimensions(targetResolution)
        : MISSING_VALUE_PLACEHOLDER;

    const sourceResText = sourceResolution
        ? stringifyOrderResolutionDimensions(sourceResolution)
        : MISSING_VALUE_PLACEHOLDER;

    return (
        <Stack tokens={{ childrenGap: 5 }}>
            <Text variant="smallPlus" value={`Target: ${targetResText}`} />
            <Text variant="smallPlus" value={`Source: ${sourceResText}`} />
        </Stack>
    );
}
